import { ChangeEvent, FC, useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { useTranslation } from "react-i18next";
import CustomLabelInput from "@components/CustomLabelInput";
import { Box } from "@mui/material";

const Container = styled(Box)`
  width: 200px;
  height: 200px;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
`;

const FileInput = styled.input`
  display: none;
`;

interface UserAvatarProps {
  image?: string;
  onChange?: (image: File | undefined | null) => void;
}

const UserAvatar: FC<UserAvatarProps> = ({ image, onChange }) => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState<string | undefined>();
  const fileRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    setSelectedImage(image);
  }, [image]);

  const selectImage = () => {
    if (!fileRef.current) {
      return;
    }

    fileRef.current.click();
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = (event as any).target.files[0];
    if (file) {
      setSelectedImage(URL.createObjectURL(file));
    }
    onChange?.(file);
  };

  const style = selectedImage
    ? { backgroundImage: `url('${selectedImage}')` }
    : {};

  return (
    <CustomLabelInput label={t("personForm.picture.label")} id="avatar-input">
      <Container
        style={style}
        onClick={selectImage}
        border={`${selectedImage ? "solid" : "dashed"} 1px #bdc1caff`}
      >
        {!selectedImage && <AddOutlinedIcon sx={{ color: "#6F7787FF" }} />}
        <FileInput
          id="avatar-input"
          type="file"
          accept="image/*"
          ref={fileRef}
          onChange={handleChange}
        />
      </Container>
    </CustomLabelInput>
  );
};

export default UserAvatar;
